// src/lib/adjustReasons.js
// #364 + #369, Session 78g.
//
// The adjust reason codes were a module-local const in InventoryActionCatalog.js.
// #364 puts an Adjust sheet on the item detail page too, and copying the list
// there would have created a second definition of a vocabulary that #369's
// notification guard compares against by value — the precise drift that turned
// getStatus() into four disagreeing copies (see src/lib/stockStatus.js).
//
// Opening count is Stede's SAP 561: the first-time load of a stock balance
// rather than the correction of a discrepancy. #369 suppresses the branch
// manager notification for it and only for it, so this string is load-bearing
// and is named rather than repeated at the comparison site.
export const REASON_OPENING_COUNT = 'Opening count';

export const ADJUST_REASONS = [
  'Count correction',
  'Damaged / write-off',
  'Lost / shrinkage',
  'Transfer correction',
  'Vendor return',
  REASON_OPENING_COUNT,
];
